module.exports = __webpack_public_path__ + "img/verify-now-logo.0dd9bd05.svg";